import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

const BillingSuccess = () => {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("polling");
  const [tries, setTries] = useState(0);
  const triesRef = useRef(0);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let cancelled = false;
    triesRef.current = 0;
    const tick = async () => {
      try {
        const r = await api.get(`/billing/status/${sid}`);
        if (cancelled) return;
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (triesRef.current >= 12) { setStatus("timeout"); return; }
        triesRef.current += 1;
        setTries(triesRef.current);
        setTimeout(tick, 2000);
      } catch { if (!cancelled) setStatus("error"); }
    };
    tick();
    return () => { cancelled = true; };
    // params is a stable URLSearchParams object; api is module-level.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center">
      {status === "polling" && (
        <>
          <Loader2 className="w-10 h-10 mx-auto animate-spin"/>
          <div className="font-serif-display text-5xl mt-8">Signing your contract…</div>
          <div className="text-black/60 mt-3 font-mono-eyebrow">Confirming your subscription with Stripe</div>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="w-14 h-14 mx-auto text-[color:var(--accent)]"/>
          <div className="font-serif-display text-6xl mt-6">Welcome, member.</div>
          <div className="text-black/60 mt-4">Your Atelier Premium is now active. The full studio is yours.</div>
          <div className="flex gap-3 justify-center mt-10">
            <Link to="/studio" className="btn-ink" data-testid="success-studio">Enter the studio</Link>
            <Link to="/outfits" className="btn-outline-ink">See archive</Link>
          </div>
        </>
      )}
      {(status === "timeout" || status === "error") && (
        <>
          <div className="font-serif-display text-4xl">Payment still processing.</div>
          <div className="text-black/60 mt-4">Refresh in a moment, or check the billing status on your profile.</div>
          <button onClick={()=>nav("/profile")} className="btn-outline-ink mt-8">Go to profile</button>
        </>
      )}
    </div>
  );
};

export default BillingSuccess;
